export default __webpack_public_path__ + "static/media/LONG.13fedea3.svg";